import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {
  CheckoutSteps, DiscountConditionType,
  PaymentOptionJSON
} from "../../../../../common";
import {Cart, DiscountEntry} from "../../../../../common";
import {AppService, getStepRoute, Host} from "../../../../../common";

@Component({
  selector: 'payment',
  standalone: false,
  templateUrl: './payment.html'
})
export class PaymentPage implements OnInit, OnDestroy {

  cart: Cart;
  host: Host;
  payment_options: PaymentOptionJSON[];

  // make enum available in template
  CheckoutSteps = CheckoutSteps;

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private appService: AppService
  ) {
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.appService.load().subscribe(({host, menu, table, cart}) => {
        this.host = host;
        this.cart = cart;
        const total = this.cart.getNetTotal();  // needed to calculate amount for discount
        if (this.cart.positions.length == 0) {
          this.router.navigate(['/'])
        }
        this.payment_options = cart.getVisiblePaymentOptions().map((opt) => { return {
          discounts: host.discounts
              .filter(d => d.appliesTo(DiscountConditionType.PaymentMethod, opt.slug))
              .map(d => new DiscountEntry(this.cart, d, d.getAmount(this.cart, total), 0)),
          ...opt
        }});
      })
    );
  }

  ngOnDestroy(): void {
    let sub = null;
    while (sub = this.subscriptions.pop()) {
      sub.unsubscribe();
    }
  }

  setPayment(payment) {
    this.cart.setPayment(payment);
    return false;
  }

  canProceed(): boolean {
    return !!(this.cart.getPaymentIsValid());
  }

  getNextStep() {
    return this.cart.getNextCheckoutStep();
  }

  back() {
    this.location.back()
  }

  next() {
    if (this.canProceed()) {
      this.cart.save();
      this.router.navigate(getStepRoute(this.getNextStep()))
    }
  }

}
